class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key || parsedState.items?.[0]?.key;
    const sections = this.getSectionsToRender();
    sections.sort((a, b) => Number(b.id === 'cart-icon-bubble') - Number(a.id === 'cart-icon-bubble'));
    sections.forEach((section) => {
      const target = document.getElementById(section.id);
      const html = this.getSectionInnerHTML(parsedState.sections?.[section.id], section.selector);
      if (target && html !== null) target.innerHTML = html;
    });

    if (!parsedState.sections?.['cart-icon-bubble']) this.refreshCartIcon();
    if (this.header) this.header.reveal();
    this.open();
  }

  refreshCartIcon() {
    return fetch(`${routes.cart_url}?sections=cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => {
        const icon = document.getElementById('cart-icon-bubble');
        const html = this.getSectionInnerHTML(sections['cart-icon-bubble']);
        if (icon && html !== null) icon.innerHTML = html;
      })
      .catch((error) => console.error(error));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (typeof html !== 'string') return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML ?? null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
